import { Button } from "@/components/UI/Button";

interface IColorPicker {
  color: string;
  onColorChange: (color: string) => void;
  onReset: () => void;
  label?: string;
  onPickerFocus?: () => void;
  onPickerBlur?: () => void;
}

function ColorPicker({
  color,
  onColorChange,
  onReset,
  label,
  onPickerFocus,
  onPickerBlur,
}: IColorPicker) {
  return (
    <div className="flex items-center gap-3">
      {label && <div className="text-sm font-medium">{label}</div>}

      <div className="flex items-center gap-2">
        <div className="relative">
          <input
            type="color"
            value={color}
            onChange={(e) => onColorChange(e.target.value)}
            onFocus={onPickerFocus}
            onBlur={onPickerBlur}
            className="h-8 w-12 cursor-pointer rounded border border-gray-300 dark:border-gray-600"
          />
        </div>

        <Button
          onClick={onReset}
          variant="settingsAction"
          className="ml-2"
          title="Reset to default"
        >
          Reset
        </Button>
      </div>
    </div>
  );
}

export default ColorPicker;
